import { GenericState } from 'src/app/common/store/types';
import {
  GroupedLabelWithValue,
  LabelWithValue,
  MarketingPerformanceReportItem,
  Period,
  SalesPerformanceFacetItem,
  SalesPerformanceReportItem,
  CallsPerformanceReportItem,
} from './types';
import { onApiCall } from 'src/app/common/store/generic.reducer';
import { reportingActions } from './reporting.actions';
import { createReducer, ActionReducer, Action, on } from '@ngrx/store';

export interface IReportingState {
  getReportByFilter: GenericState<any[]>;
  getReportFemalePeopleByAge: GenericState<any[]>;
  getReportMalePeopleByAge: GenericState<any[]>;
  getReportPeopleByRegime: GenericState<any[]>;
  getLeadsByDayAndHoursRange: GenericState<any[]>;
  getReportLeadsTopCities: GenericState<any[]>;
  getPeriods: GenericState<Period[]>;
  barGraphStartDate: string;
  barGraphEndDate: string;
  getLeadCount: GenericState<number>;
  getConversionRateCount: GenericState<number>;
  getRawContractCount: GenericState<number>;
  getValidatedContractCount: GenericState<number>;
  getReportLeadsByCategory: GenericState<any[]>;
  getReportContractsByProductCategory: GenericState<any[]>;
  getReportLeadsBySource: GenericState<any[]>;
  getReportContractsBySource: GenericState<any[]>;
  getReportLeadsBySalesPerson: GenericState<any[]>;
  getReportContractsBySalesPerson: GenericState<any[]>;
  getReportMonthlyProgress: GenericState<GroupedLabelWithValue[]>;
  getReportSalesTotalAndObjectives: GenericState<GroupedLabelWithValue[]>;
  getSalesPerformance: GenericState<SalesPerformanceReportItem[]>;
  getSalesPerformanceFacetItems: GenericState<SalesPerformanceFacetItem[]>;
  getCallsPerformance: GenericState<CallsPerformanceReportItem[]>;
  getMarketingPerformance: GenericState<MarketingPerformanceReportItem[]>;
}

export const reportingInitialState: IReportingState = {
  getReportByFilter: new GenericState<any[]>(),
  getReportFemalePeopleByAge: new GenericState<any[]>(),
  getReportMalePeopleByAge: new GenericState<any[]>(),
  getReportPeopleByRegime: new GenericState<any[]>(),
  getLeadsByDayAndHoursRange: new GenericState<any[]>(),
  getReportLeadsTopCities: new GenericState<any[]>(),
  getPeriods: new GenericState<Period[]>(),
  barGraphStartDate: '',
  barGraphEndDate: '',
  getLeadCount: new GenericState<number>(),
  getConversionRateCount: new GenericState<number>(),
  getRawContractCount: new GenericState<number>(),
  getValidatedContractCount: new GenericState<number>(),
  getReportLeadsByCategory: new GenericState<any[]>(),
  getReportContractsByProductCategory: new GenericState<any[]>(),
  getReportLeadsBySource: new GenericState<any[]>(),
  getReportContractsBySource: new GenericState<any[]>(),
  getReportLeadsBySalesPerson: new GenericState<any[]>(),
  getReportContractsBySalesPerson: new GenericState<any[]>(),
  getReportMonthlyProgress: new GenericState<GroupedLabelWithValue[]>(),
  getReportSalesTotalAndObjectives: new GenericState<GroupedLabelWithValue[]>(),
  getSalesPerformance: new GenericState<SalesPerformanceReportItem[]>(),
  getSalesPerformanceFacetItems: new GenericState<SalesPerformanceFacetItem[]>(),
  getCallsPerformance: new GenericState<CallsPerformanceReportItem[]>(),
  getMarketingPerformance: new GenericState<MarketingPerformanceReportItem[]>(),
};

const reportingReducers = [
  ...onApiCall<any[]>(reportingActions.getReportByFilter, 'getReportByFilter'),
  ...onApiCall<any[]>(
    reportingActions.getReportFemalePeopleByAge,
    'getReportFemalePeopleByAge',
  ),
  ...onApiCall<any[]>(
    reportingActions.getReportMalePeopleByAge,
    'getReportMalePeopleByAge',
  ),
  ...onApiCall<any[]>(
    reportingActions.getReportPeopleByRegime,
    'getReportPeopleByRegime',
  ),
  ...onApiCall<any[]>(
    reportingActions.getLeadsByDayAndHoursRange,
    'getLeadsByDayAndHoursRange',
  ),
  ...onApiCall<any[]>(
    reportingActions.getReportLeadsByCity,
    'getReportLeadsByCity',
  ),
  ...onApiCall<number>(reportingActions.getLeadCount, 'getLeadCount'),
  ...onApiCall<number>(
    reportingActions.getConversionRateCount,
    'getConversionRateCount',
  ),
  ...onApiCall<number>(
    reportingActions.getRawContractCount,
    'getRawContractCount',
  ),
  ...onApiCall<number>(
    reportingActions.getValidatedContractCount,
    'getValidatedContractCount',
  ),
  ...onApiCall<any[]>(
    reportingActions.getReportLeadsByCategory,
    'getReportLeadsByCategory',
  ),
  ...onApiCall<any[]>(
    reportingActions.getReportContractsByProductCategory,
    'getReportContractsByProductCategory',
  ),
  ...onApiCall<any[]>(
    reportingActions.getReportLeadsBySource,
    'getReportLeadsBySource',
  ),
  ...onApiCall<any[]>(
    reportingActions.getReportContractsBySource,
    'getReportContractsBySource',
  ),
  ...onApiCall<any[]>(
    reportingActions.getReportLeadsBySalesPerson,
    'getReportLeadsBySalesPerson',
  ),
  ...onApiCall<any[]>(
    reportingActions.getReportContractsBySalesPerson,
    'getReportContractsBySalesPerson',
  ),
  ...onApiCall<GroupedLabelWithValue[]>(
    reportingActions.getReportMonthlyProgress,
    'getReportMonthlyProgress',
  ),
  ...onApiCall<GroupedLabelWithValue[]>(
    reportingActions.getReportSalesTotalAndObjectives,
    'getReportSalesTotalAndObjectives',
  ),
  ...onApiCall<CallsPerformanceReportItem[]>(
    reportingActions.getCallsPerformance,
    'getCallsPerformance',
  ),
  ...onApiCall<SalesPerformanceReportItem[]>(
    reportingActions.getSalesPerformance,
    'getSalesPerformance',
  ),
  ...onApiCall<SalesPerformanceFacetItem[]>(
    reportingActions.getSalesPerformanceFacetItems,
    'getSalesPerformanceFacetItems',
  ),
  ...onApiCall<MarketingPerformanceReportItem[]>(
    reportingActions.getMarketingPerformance,
    'getMarketingPerformance',
  ),
  ...onApiCall<Period[]>(reportingActions.getPeriods, 'getPeriods'),
  on(
    reportingActions.setBarGraphStartDate,
    (state: IReportingState, { barGraphStartDate }) => ({
      ...state,
      barGraphStartDate: barGraphStartDate,
    }),
  ),
  on(
    reportingActions.setBarGraphEndDate,
    (state: IReportingState, { barGraphEndDate }) => ({
      ...state,
      barGraphEndDate: barGraphEndDate,
    }),
  ),
];

export const reportingReducer = createReducer(
  reportingInitialState,
  ...reportingReducers,
) as ActionReducer<IReportingState, Action>;

export function useReducerFunc(state: any | undefined, action: Action) {
  return reportingReducer(state, action);
}
